/**
 * Display formatting. pt-BR and BRL only — there is no i18n library and no plan for one
 * (`AGENTS.md`). Kept out of `src/lib/pricing/` because formatting is not pricing.
 */

export function brl(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function decimal(value: number): string {
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * The recurrence suffix beside a plan's price — "R$ 39,90" + "/ano".
 *
 * Shared rather than written at each call site because the two surfaces that price a plan
 * (`/planos` and the marketplace paywall) must not disagree about what a subscriber is
 * being charged: the paywall hardcoded "/mês" and went on saying it after Pro became a
 * yearly plan, which advertised a whole year's price as a monthly one.
 *
 * A one-off charge has no recurrence to name, and an unrecognised value gets no suffix
 * either — inventing "/mês" for something we cannot identify is the original bug.
 */
export function intervalSuffix(interval: string): string {
  switch (interval) {
    case 'month':
      return '/mês'
    case 'year':
      return '/ano'
    default:
      return ''
  }
}
